import React, { useContext } from "react";
import { PhoneIcon } from "@heroicons/react/solid";
import { ButtonBase } from "@reusejs/react";
import { useRouter } from "next/router";
import BidSvg from "../../Icons/BidSvg";
import { Context } from "services";

export default function InvestComponent() {
  const router = useRouter();
  const { searchForm }: any = useContext(Context);

  return (
    <div className="pt-16 bg-blue-600 overflow-hidden">
      <div className="relative max-w-xl mx-auto px-4 xl:px-0 sm:px-6 lg:px-8 lg:max-w-7xl">
        <div className="hidden md:block">
          <div className="relative">
            <div className="lg:grid lg:grid-flow-row-dense lg:grid-cols-2 lg:gap-8 lg:items-center">
              <div className="lg:col-start-2 flex justify-center">
                <BidSvg />
              </div>

              <div className="relative lg:col-start-1">
                <div className="relative py-2">
                  <h3 className="text-3xl text-white font-extrabold tracking-tight sm:text-4xl">
                    Ready to invest?
                  </h3>
                  <h2 className="text-3xl text-white font-extrabold tracking-tight sm:text-4xl">
                    Bid in Auction properties
                  </h2>

                  <div className="mt-2 pr-24 text-xl text-gray-300">
                    {`Auction property is a win-win proposal for both banks and buyers. It's a great advantage for the users to get the property at a discounted rate compared to the market price.`}
                  </div>
                  <div className="flex flex-row mt-6">
                    <div className="mr-2">
                      <ButtonBase
                        variant="primary"
                        type="submit"
                        label="Explore properties"
                        onClick={() => {
                          searchForm.setField("asset_type", "");
                          searchForm.setField("sub_asset_type", "");
                          searchForm.setField("state", "");
                          searchForm.setField("city", "");
                          searchForm.setField("reserve_price", "");
                          searchForm.setField("institutes", "");
                          searchForm.setField("filter_by", "");
                          searchForm.setField("sort_by", "");
                          searchForm.setField("total", "");
                          router.push("/auction-properties");
                        }}
                        buttonBaseClasses={{
                          font: "text-sm font-medium",
                          backgroundColor: "bg-white hover:bg-transparent",
                          textColor: "text-blue-600 hover:text-white",
                          border: "border border-blue-600 hover:border-white",
                          padding: "px-4 py-3",
                        }}
                      />
                    </div>
                    <ButtonBase
                      variant="primary"
                      type="submit"
                      label="Talk to our experts"
                      buttonPrefix={
                        <PhoneIcon width="20" height="20" className="mr-2" />
                      }
                      onClick={() => {
                        console.log("button clicked");
                      }}
                      buttonBaseClasses={{
                        font: "text-sm font-medium",
                        backgroundColor: "bg-transparent hover:bg-white",
                        textColor: "text-white hover:text-blue-600",
                        border: "border border-white hover:border-blue-700",
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="block md:hidden ">
          <div className="relative">
            <div className="lg:grid lg:grid-flow-row-dense lg:grid-cols-2 lg:gap-8 lg:items-center">
              <div className="relative lg:col-start-1">
                <div className="relative py-2">
                  <h3 className="text-2xl text-white font-extrabold tracking-tight sm:text-4xl">
                    Ready to invest?
                  </h3>
                  <h2 className="text-2xl text-white font-extrabold tracking-tight sm:text-4xl">
                    Bid in Auction properties
                  </h2>

                  <div className="mt-2 pr-8 text-sm text-gray-300">
                    {`Auction property is a win-win proposal for both banks and buyers. It's a great advantage for the users to get the property at a discounted rate compared to the market price.`}
                  </div>
                  <div className="flex flex-col mt-6">
                    <div className="mb-2">
                      <ButtonBase
                        variant="primary"
                        type="submit"
                        label="Explore properties"
                        onClick={() => {
                          searchForm.setField("asset_type", "");
                          searchForm.setField("sub_asset_type", "");
                          searchForm.setField("state", "");
                          searchForm.setField("city", "");
                          searchForm.setField("reserve_price", "");
                          searchForm.setField("institutes", "");
                          searchForm.setField("filter_by", "");
                          searchForm.setField("sort_by", "");
                          searchForm.setField("total", "");
                          router.push("/auction-properties");
                        }}
                        buttonBaseClasses={{
                          font: "text-sm font-medium",
                          backgroundColor: "bg-white hover:bg-transparent",
                          textColor: "text-blue-600 hover:text-white",
                          border: "border border-blue-600 hover:border-white",
                          padding: "px-4 py-3",
                          width: "w-full",
                        }}
                      />
                    </div>
                    <ButtonBase
                      variant="primary"
                      type="submit"
                      label="Talk to our experts"
                      buttonPrefix={
                        <PhoneIcon width="20" height="20" className="mr-2" />
                      }
                      onClick={() => {
                        console.log("button clicked");
                      }}
                      buttonBaseClasses={{
                        font: "text-sm font-medium",
                        backgroundColor: "bg-transparent hover:bg-white",
                        textColor: "text-white hover:text-blue-600",
                        border: "border border-white hover:border-blue-700",
                        width: "w-full",
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="flex justify-center">
                <BidSvg />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
